"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const geocoderService = {
  search: function (options) {
    return api.get("/Geocoder/Search", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  reverse: function (options) {
    return api.get("/Geocoder/Reverse", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default geocoderService;
